import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import { apiError, loginSuccess, logoutUserSuccess } from "./actions"
import { getUserByToken } from "../../../crud/auth.crud";
import { SET_CODE } from 'store/auth/data/actionTypes';
import store from 'store';

//Include Both Helper File with needed methods
// import { getFirebaseBackend } from "../../../helpers/firebase_helper"
// import {
//   postFakeLogin,
//   postJwtLogin,
//   postSocialLogin,
// } from "../../../helpers/fakebackend_helper"

//const fireBaseBackend = getFirebaseBackend()

function* loginUser({ payload: { user, history } }) {
  try {   
    const response = yield getUserByToken();
    if(response.data?.data?.[0]?.type === 'driver'){
      store.dispatch({ type: SET_CODE, data: null})
      alert('웹에서 지원되지 않는 회원유형입니다. 앱을 이용해주세요.')
    }else{
      localStorage.setItem("authUser", JSON.stringify(response.data?.data?.[0]))
      yield put(loginSuccess(response.data?.data?.[0]))
      history.push("/dashboard")
    }
  } catch (error) {
    yield put(apiError(error))
  }
}

function* logoutUser({ payload }) {
  try {
    localStorage.removeItem("authUser")
    yield put(logoutUserSuccess())  
    window.location.href = '/main'
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeLatest(LOGIN_USER, loginUser)
  yield takeLatest(LOGOUT_USER, logoutUser)
}

export default authSaga
